//#region INTERFACE IAutoOrderListStatusChips

/**
 * ### Interface IAutoOrderListStatusChips
 * Represents the status chip flags for different auto order list states.
 *
 * @interface IAutoOrderListStatusChips
 * @default {@link AutoOrderListStatusChipsDefaults}
 * @description Holds boolean toggles indicating the current visibility or activity status
 *              of various order states such as open, prepared, failed, or completed.
 *
 * @example
 * const statusChips: IAutoOrderListStatusChips = {
 *   open_orders: false,
 *   prepared: false,
 *   failed: false,
 *   completed: false,
 * };
 *
 * @extends Object
 */
export interface IAutoOrderListStatusChips extends Object {
  /**
   * Whether orders are completed.
   * @type {boolean}
   * @default false
   * @example true
   */
  completed: boolean;

  /**
   * Whether there are failed orders.
   * @type {boolean}
   * @default false
   * @example false
   */
  failed: boolean;

  /**
   * Whether there are open orders.
   * @type {boolean}
   * @default false
   * @example true
   */
  open_orders: boolean;

  /**
   * Whether orders are prepared.
   * @type {boolean}
   * @default false
   * @example false
   */
  prepared: boolean;
}

//#endregion

//#region CONST AutoOrderListStatusChipsDefaults

/**
 * ### Constant AutoOrderListStatusChipsDefaults
 * Default state for the auto order list status chips flags.
 *
 * @constant AutoOrderListStatusChipsDefaults
 * @type {IAutoOrderListStatusChips}
 * @description Used to initialize or reset status chip flags in the auto order list UI.
 *
 * @example
 * const defaultStatusChips = AutoOrderListStatusChipsDefaults;
 * {
 *   open_orders: false,
 *   prepared: false,
 *   failed: false,
 *   completed: false,
 * }
 */
export const AutoOrderListStatusChipsDefaults: IAutoOrderListStatusChips = {
  open_orders: false,
  prepared: false,
  failed: false,
  completed: false,
};
//#endregion
